// Turn react-table's `rows` (already expanded and sorted, i.e. exactly what
// is on screen) into flat CSV records.
export const toExportRows = (tableRows) => (tableRows || []).map(({ original }) => {
  const { subRows, ...record } = original;
  return record;
});
